import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Region } from '@/types';
import { useGetRegionsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchRegions<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Region> } & Omit<
  AutocompleteProps<Region, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetRegionsQueryProps = useAsyncSearch<Region, Multiple, DisableClearable, FreeSolo>(
    useGetRegionsQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetRegionsQueryProps} />;
}

export default SearchRegions;
